// extracted by mini-css-extract-plugin
module.exports = {"tinyRegistrationFormRow":"TinyRegistrationForm__tinyRegistrationFormRow","tinyRegistrationControl":"TinyRegistrationForm__tinyRegistrationControl"};